import { mxn } from "@/lib/format";

export const diferencia = (suma, autorizado) => Math.round((suma - (Number(autorizado) || 0)) * 100) / 100;

/** Suma de integrantes contra el monto autorizado por el Comité (candado de contratación). */
export function CuadreAutorizado({ suma, autorizado }) {
  const aut = Number(autorizado) || 0;
  const dif = diferencia(suma, aut);
  return (
    <div className="mt-2 grid grid-cols-1 gap-1 rounded-md border border-slate-200 bg-white p-2 text-xs sm:grid-cols-3" data-testid="integrantes-cuadre">
      <span>Suma de integrantes: <b data-testid="integrantes-suma-contratar">{mxn(suma)}</b></span>
      <span>Monto autorizado por el Comité: <b data-testid="integrantes-autorizado">{aut > 0 ? mxn(aut) : "Sin monto autorizado"}</b></span>
      <span className={dif === 0 ? "text-emerald-700" : "text-red-600"} data-testid="integrantes-diferencia">
        {dif === 0 ? "Cuadra con lo autorizado" : dif > 0 ? `Sobran ${mxn(dif)}` : `Faltan ${mxn(-dif)}`}
      </span>
    </div>
  );
}
